











import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class TripDestinationsSelect extends Vue {
  selectedTripDestinations: number;

  @Prop({ required: true }) value: number | null;
 
  @Watch('value', { immediate: true }) onValueChanged() {
    if (this.value === null || this.value === undefined) {
      return this.selectTripDestinations(-1);
    }
    this.selectedTripDestinations = this.value;
  }

  get tripDestinations() {
    return [
      { 
        text: this.$i18n.translate("generic.select", "Select"), 
        value: -1 
      },
      { 
        text: this.$i18n.translate( "transportationPermission.tripDestinations.homeToMain", "Home-Main place" ),
        value: 0,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.grouping", "Grouping"),
        value: 1,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.passengerDestinations", "Passengers destinations"),
        value: 2,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.homeSecondary", "Home-Secondary place"),
        value: 4,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.mainSecondary", "Main-Secondary place"),
        value: 5,
      },
      {
        text: this.$i18n.translate("transportationPermission.tripDestinations.allDestinations", "All destinations"),
        value: 3,
      },
    ];
  }

  selectTripDestinations(tripDestinations: number) {
    this.selectedTripDestinations = tripDestinations;
    this.$emit('input', this.selectedTripDestinations);
  }

}
